module.exports = __webpack_public_path__ + "static/media/DevPortal-Homepage-Illustration.8b29f9da.png";